// 経路。React Router のライブラリ方式（BrowserRouter）。ログイン以外はセッションが要る。
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from 'react-router';
import { loadSession, loginPathFor } from './lib/auth';
import { OfficeProvider } from './lib/office';
import { Shell } from './components/Shell';
import { LoginPage } from './pages/Login';
import { LoginCallbackPage } from './pages/LoginCallback';
import { DashboardPage } from './pages/Dashboard';
import { ClientsPage } from './pages/Clients';
import { AgentTab, ClientDetailPage, DocumentView, DocumentsTab, RecordsTab } from './pages/ClientDetail';
import { SettingsPage } from './pages/Settings';
import { OpsPage } from './pages/Ops';

function RequireAuth() {
  const loc = useLocation();
  // 期限切れでも更新トークンがあれば API 呼び出し時に更新する。拒否されたら api.ts がログインへ戻す
  if (!loadSession()) return <Navigate to={loginPathFor(loc.pathname + loc.search)} replace />;
  return (
    <OfficeProvider>
      <Outlet />
    </OfficeProvider>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/login/callback" element={<LoginCallbackPage />} />
        <Route element={<RequireAuth />}>
          <Route element={<Shell />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/clients/:clientId" element={<ClientDetailPage />}>
              <Route index element={<Navigate to="records" replace />} />
              <Route path="records" element={<RecordsTab />} />
              <Route path="documents" element={<DocumentsTab />} />
              <Route path="documents/:documentId" element={<DocumentView />} />
              <Route path="agent" element={<AgentTab />} />
            </Route>
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/ops" element={<OpsPage />} />
          </Route>
        </Route>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
